/**
 * Actieteller: alleen woensdag / donderdag (Europe/Amsterdam via uf-lf-actie-schedule.js).
 */
(function (w) {
  'use strict';

  var findState = w.UF_LF_ACTIE && w.UF_LF_ACTIE.findState;

  function remainingDHMS(from, to) {
    var ms = to - from;
    if (ms <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    var totalSec = Math.floor(ms / 1000);
    var days = Math.floor(totalSec / 86400);
    var r = totalSec % 86400;
    var hours = Math.floor(r / 3600);
    r = r % 3600;
    var minutes = Math.floor(r / 60);
    var seconds = r % 60;
    return { days: days, hours: hours, minutes: minutes, seconds: seconds };
  }

  function pad2(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function pulseTile(numEl) {
    if (!numEl) return;
    var tile = numEl.closest('.uf-lf-promo-countdown__tile');
    if (!tile) return;
    if (tile._ufLfPromoPulseT) w.clearTimeout(tile._ufLfPromoPulseT);
    tile.classList.remove('is-tick');
    if (tile._ufLfPromoRaf) w.cancelAnimationFrame(tile._ufLfPromoRaf);
    tile._ufLfPromoRaf = w.requestAnimationFrame(function () {
      tile._ufLfPromoRaf = null;
      tile.classList.add('is-tick');
      tile._ufLfPromoPulseT = w.setTimeout(function () {
        tile._ufLfPromoPulseT = null;
        tile.classList.remove('is-tick');
      }, 520);
    });
  }

  function setDigit(numEl, text, animate) {
    if (!numEl) return;
    if (numEl.textContent === text) return;
    numEl.textContent = text;
    if (animate) pulseTile(numEl);
  }

  function formatPct(pct) {
    var n = Number(pct) || 0;
    if (n <= 0) return '';
    return '−' + String(n).replace('.', ',') + '%';
  }

  function mount(root, labels) {
    if (!root) return;
    var headingEl = root.querySelector('[data-uf-lf-promo-heading]');
    var nameEl = root.querySelector('[data-uf-lf-promo-name]');
    var pctEl = root.querySelector('[data-uf-lf-promo-pct]');
    var subEl = root.querySelector('[data-uf-lf-promo-sub]');
    var dEl = root.querySelector('[data-uf-lf-promo-d]');
    var hEl = root.querySelector('[data-uf-lf-promo-h]');
    var miEl = root.querySelector('[data-uf-lf-promo-mi]');
    var sEl = root.querySelector('[data-uf-lf-promo-s]');
    var tiles = root.querySelector('[data-uf-lf-promo-tiles]');

    labels = labels || {};
    var L = {
      days: labels.days || 'Dagen',
      hours: labels.hours || 'Uren',
      minutes: labels.minutes || 'Minuten',
      seconds: labels.seconds || 'Seconden',
      headingActive: labels.headingActive || 'Lopende actie',
      subActive: labels.subActive || 'Eindigt over'
    };

    function tick() {
      var state = typeof findState === 'function' ? findState(new Date()) : null;
      if (!state || state.mode !== 'active' || !state.entry) {
        root.setAttribute('hidden', '');
        return;
      }
      root.removeAttribute('hidden');
      var entry = state.entry;
      var target = state.target;
      var now = new Date();

      if (headingEl) headingEl.textContent = state.saleLabel || L.headingActive;
      if (subEl) subEl.textContent = L.subActive;
      if (nameEl) nameEl.textContent = entry.name;
      if (pctEl) {
        var pctText = formatPct(entry.pct);
        pctEl.textContent = pctText;
        pctEl.hidden = !pctText;
      }

      var p = remainingDHMS(now, target);
      setDigit(dEl, String(p.days), true);
      setDigit(hEl, pad2(p.hours), true);
      setDigit(miEl, pad2(p.minutes), true);
      setDigit(sEl, pad2(p.seconds), true);

      if (tiles) {
        var uD = tiles.querySelector('[data-uf-lf-promo-unit-d]');
        var uH = tiles.querySelector('[data-uf-lf-promo-unit-h]');
        var uMi = tiles.querySelector('[data-uf-lf-promo-unit-mi]');
        var uS = tiles.querySelector('[data-uf-lf-promo-unit-s]');
        if (uD) uD.textContent = L.days;
        if (uH) uH.textContent = L.hours;
        if (uMi) uMi.textContent = L.minutes;
        if (uS) uS.textContent = L.seconds;
      }
    }

    function alignSecondBoundary() {
      tick();
      var ms = 1000 - (Date.now() % 1000);
      w.setTimeout(function loop() {
        tick();
        w.setTimeout(loop, 1000);
      }, ms);
    }

    alignSecondBoundary();
  }

  w.UfLfPromoCountdown = {
    mount: mount,
    _findState: findState
  };
})(window);
